const constants = {
  status: {
    IN_PROGRESS: 'In Progress',
    SUBMITTED: 'Submitted',
    CHANGES_REQUESTED: 'Changes Requested',
    REJECTED_PROVISIONALLY: 'Rejected Provisionally',
    REJECTED: 'Rejected',
    ABANDONED: 'Abandoned',
    APPROVED_PROVISIONALLY: 'Approved Provisionally',
    APPROVED_LICENCE_PENDING: 'Approved Licence Pending',
    APPROVED_LICENCE_ISSUED: 'Approved Licence Issued',
  },
};

export default constants;
